import { render, staticRenderFns } from "./ReviewChart.vue?vue&type=template&id=05579949"
import script from "./ReviewChart.vue?vue&type=script&lang=js"
export * from "./ReviewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports